import React from 'react';
import {
  IconButton,
  Box,
} from '@chakra-ui/react';
import { EditIcon } from '@chakra-ui/icons';
import { IRole } from '../../lib/graphql';
import { useAuth } from '../../pages/api/userAuth';

interface AdminEditButtonProps {
  resourceType: 'Term' | 'CourseGroup' | 'OnlineCourse' | 'StudioCourse';
  id: string | number;
  position?: 'top-right' | 'inline';
}

const AdminEditButton: React.FC<AdminEditButtonProps> = ({
  resourceType,
  id,
  position = 'top-right',
}) => {
  const { user } = useAuth();

  // Only show for admin users
  if (!user?.roles.includes(IRole.Admin)) {
    return null;
  }

  // Determine base URL based on environment
  const isLocalhost = typeof window !== 'undefined'
    && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

  const baseUrl = isLocalhost
    ? 'http://localhost:4000'
    : 'https://api.ukchinaperformingarts.com';

  const adminUrl = `${baseUrl}/admin/resources/${resourceType}/records/${id}/show`;

  const handleEdit = () => {
    window.open(adminUrl, '_blank');
  };

  const buttonComponent = (
    <IconButton
      aria-label="Edit in admin"
      icon={<EditIcon />}
      size="sm"
      colorScheme="orange"
      variant="solid"
      onClick={handleEdit}
      title={`Edit ${resourceType} in admin`}
      zIndex={10}
    />
  );

  if (position === 'inline') {
    return buttonComponent;
  }

  // Default top-right positioning
  return (
    <Box
      position="absolute"
      top={2}
      right={2}
      zIndex={10}
    >
      {buttonComponent}
    </Box>
  );
};

export default AdminEditButton;
